module.exports = __webpack_public_path__ + "media/images/pic/rodzice-witusia-4b1a5c9d4a1dc7645c1f707b9843068c.jpeg";